<template>	
	<div>
			<div class="mfty-box">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Maob-APS高级计划与排程系统
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row" style="justify-content: space-between;">
						<img src="../../assets/img/APSImg.png" />
						<div class="col" style="margin-left: 25px;justify-content: flex-start;">
							<div class="item-no" style="font-size: 24px;color: #000;">
								什么是Maob-APS高级计划与排程系统？
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;margin-top: 30px;line-height: 25px;text-align: left;">
								APS系统，又名高级计划与排程(Advanced Planning and Scheduling)，企业管理软件。								APS系统是对所有资源具有同步的，实时的，具有约束能力的，模拟能力，不论是物料，机器设备，人员，供应，客户需求，运输等影响计划因素，让您能够在考虑交付达成率和库存水平的同时，优化资源利用率帮助提升企业生产效率，真正实现：
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 40px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 生产计划可视化呈现与控制
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 20px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 快速有效响应不同场景的生产计划
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 20px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 提高准时交货能力
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 20px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 提高产能和资源利用率
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			<div class="mfty-box" style="background-color: #f3f3f3;height: 700px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					车间管理常见问题
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row">
						<div class="col al-c">
							<img src="../../assets/img/APSicon1.png" />
							<div class="item ju-c" style="margin-top: 25px;">
								资源利用率不高
							</div>
							
						</div>
						<div class="col al-c">
							<img src="../../assets/img/APSicon2.png" />
							<div class="item ju-c" style="margin-top: 25px;">
								频繁的计划变更
							</div>
							
						</div>
						<div class="col al-c">
							<img src="../../assets/img/APSicon3.png" />
							<div class="item ju-c" style="margin-top: 25px;">
								交货交期不及时
							</div>
							
						</div>
					</div>
					<div class="row" style="margin-top: 60px;">
						<div class="col al-c">
							<img src="../../assets/img/APSicon4.png" />
							<div class="item ju-c" style="margin-top: 25px;">
								库存积压成本高
							</div>
							
						</div>
						<div class="col al-c">
							<img src="../../assets/img/APSicon5.png" />
							<div class="item ju-c" style="margin-top: 25px;">
								采购计划不科学
							</div>
							
						</div>
						<div class="col al-c">
							<img src="../../assets/img/APSicon6.png" />
							<div class="item ju-c" style="margin-top: 25px;">
								紧急插单影响大
							</div>
							
						</div>
					</div>
				</div>
			</div>
			
			<div class="mfty-box" style="height: 750px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Maob-APS系统核心功能
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;position: relative;">
					<div style="background-color: #fff;width: 70px;top: 220px;left: 565px;height: 70px;border-radius: 50%;position: absolute;"></div>
					<div class="row" style="justify-content: space-between;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #0bcdcd;padding: 40px 50px;">
							 <div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								订单管理
							 </div>
							 <div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
							 	解决问题：对生产单资料进行管理，如客户、产品分类等，还包括排产关键的信息的管理，含交期、下单日期、各种生产特征、订单状态等信息。
							 </div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #20d29f;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								计划排程
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：按照设定生产条件，对生产订单进行排程，并根据车间实时状态，合理分配产能，给出最优生产计划，提高订单交付绩效。
							</div>
						</div>
					</div>
					<div class="row" style="justify-content: space-between;margin-top: 30px;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #ff9852;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								报表报告
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：提供自定义报表引擎，方便用户根据需求定制各种生产数据统计报表，直观查看相关数据。
							</div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #6f7af5;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								系统集成
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								解决问题：支持与ERP、MES、CRM等系统的相互整合集成，实现数据互通共享，从而达到企业整体信息化管理效益的最大化。
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				curHeight: 0,
				index: 1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>


	.center-body {
		margin: 0 auto;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}

	.centerbtn {
		width: 240px;
		border-radius: 25px;
		background-color: #ff7e00;
		height: 50px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.com {
		font-size: 18px;
		color: #aaaaaa;
	}

	.active {
		color: #0070FD;
	}
</style>
